import { render, staticRenderFns } from "./ReuseSucai.vue?vue&type=template&id=5381e2bc&scoped=true"
import script from "./ReuseSucai.vue?vue&type=script&lang=js"
export * from "./ReuseSucai.vue?vue&type=script&lang=js"
import style0 from "./ReuseSucai.vue?vue&type=style&index=0&id=5381e2bc&prod&lang=css"
import style1 from "./ReuseSucai.vue?vue&type=style&index=1&id=5381e2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381e2bc",
  null
  
)

export default component.exports